import modalHtml from "./error-modal-html.html";

export var errorHandler = {

    dialogComponent: null,
    otherDialogs: null,
    Bugsnag: null,

    init: function (otherDialogs, Bugsnag) {
        const self = this;
        $("body").append(modalHtml);
        this.modal = $("#errorDialog");
        this.dialogContent = $("#errorDialogContent");
        self.Bugsnag = Bugsnag;
        this.otherDialogs = otherDialogs;
        $(".error-modal-close-button").click(function () {
            self.modal.hide();
        });
        window.onerror = function (message, file, line, col, error) {
            console.error(message);
            console.error(file);
            console.error(line);
            console.error(error);
            console.log(typeof error)
            if (!error instanceof Error) {
                error = new Error(JSON.stringify(error));
            }
            self.handleAdminError(error);
            return false;
        };
        window.addEventListener("error", function (e) {
            console.error(e);
            self.handleAdminError(e);
            return false;
        });
        window.addEventListener('unhandledrejection', function (e) {
            console.error(e);
            self.handleAdminError(e);
            return false;
        });

    },

    handleError: function (err) {
        const self = this;
        OfficeHelpers.Utilities.log(err);
        if (err.code && err.code === 'InvalidOperationInCellEditMode') {
            self.showModal("Please don't edit the workbook before the execution ends.", false);
            return;
        }
        console.log(err);
        let adminMsg = err;
        if (err.stack) {
            adminMsg = adminMsg + ". \n Stack: " + err.stack;
        }
        if (err.msg) {
            adminMsg = adminMsg + ". \n Msg: " + err.msg;
        }
        if (err.code) {
            adminMsg = adminMsg + ". \n Code: " + err.code;
        }
        if (err.innerError) {
            adminMsg = adminMsg + ". \n Inner error: " + err.innerError;
        }
        if (err.innerError && err.innerError.debugInfo) {
            adminMsg = adminMsg + ". \n Debug info: " + err.innerError.debugInfo;
        }
        adminMsg = adminMsg + "\n\n" + "JSON: " + JSON.stringify(err);
        console.error(adminMsg);
        if (err.stack && err.stack.indexOf("RichApi.Error: An internal error has occurred") >= 0) {
            return;
        }
        let usrMsg = "Error occurred.<br><br>";
        if (err.code && err.code === 429) {
            usrMsg = usrMsg + "You've exceeded your credits limit, please <span class='open-pricing-page'>upgrade</span> your plan.";
        } else {
            usrMsg = usrMsg + "<br>Contact our support team anytime: <a href='mailto:support@diffbot.com' target='_blank'>support@diffbot.com</a>";
        }
        self.showModal(usrMsg);
        if (!err instanceof Error) {
            err = new Error(JSON.stringify(err));
        }
        self.Bugsnag.notify(err);
    },

    handleUserError: function (err) {
        var self = this;
        self.dialogContent.html("There was an error processing your request.<br>Error details: " + err + "<br><br>Contact support -> support@diffbot.com");
        self.showModal();
    },

    showModal: function (content, closeOtherDialogs = true) {
        const self = this;
        self.dialogContent.html(content);
        self.modal.show();
        if (closeOtherDialogs) {
            for (var i in self.otherDialogs) {
                self.otherDialogs[i].close();
            }
        }
    },

    sendAdminErrorMessage(msg) {
        OfficeHelpers.Utilities.log(msg);
        console.error(msg);
    },

    handleAdminError(err) {
        const self = this;
        OfficeHelpers.Utilities.log(err);
        console.log(err);
        let adminMsg = err;
        if (err.stack) {
            adminMsg = adminMsg + ". \n Stack: " + err.stack;
        }
        if (err.msg) {
            adminMsg = adminMsg + ". \n Msg: " + err.msg;
        }
        if (err.code) {
            adminMsg = adminMsg + ". \n Code: " + err.code;
        }
        if (err.innerError) {
            adminMsg = adminMsg + ". \n Inner error: " + err.innerError;
        }
        if (err.innerError && err.innerError.debugInfo) {
            adminMsg = adminMsg + ". \n Debug info: " + err.innerError.debugInfo;
        }
        console.error(adminMsg);
        if (!err instanceof Error) {
            err = new Error(JSON.stringify(err));
        }
        self.Bugsnag.notify(err);
    }
}